import { render, staticRenderFns } from "./GeneralAccountSettings.vue?vue&type=template&id=303c3b48&"
import script from "./GeneralAccountSettings.vue?vue&type=script&lang=ts&"
export * from "./GeneralAccountSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports